import React from "react";

import {
    Row,
    Col,
    Box,
    CampoEstatico,
    TipoCampoEstatico,
    Botao,
    TipoBotao,
    TamanhoBotao,
} from "@intechprev/componentes-web";
import { Page } from "..";
import { FichaFinancAssistidoService } from "../../services";
import {
    ContrachequeEntidade,
    FichaFinancAssistidoEntidade,
} from "../../entidades";

interface Props {
    match?: any;
}

interface State {
    contracheque: ContrachequeEntidade;
    sqProcesso: number;
    dtReferencia: string;
}

export class ContrachequeDetalhe extends React.Component<Props, State> {
    private page = React.createRef<Page>();

    constructor(props: Props) {
        super(props);

        this.state = {
            contracheque: new ContrachequeEntidade(),
            sqProcesso: props.match.params.sqProcesso,
            dtReferencia: props.match.params.dtReferencia,
        };
    }

    componentDidMount = async () => {
        await this.page.current.loading(true);

        var contracheque = await FichaFinancAssistidoService.BuscarPorProcessoReferencia(
            this.state.sqProcesso,
            this.state.dtReferencia
        );

        this.setState({ contracheque });

        await this.page.current.loading(false);
    };

    gerarRelatorio = async () => {
        var relatorio = await FichaFinancAssistidoService.BuscarRelatorioContracheque(
            this.state.sqProcesso,
            this.state.dtReferencia
        );

        if (navigator.msSaveBlob) {
            // IE10+ : (has Blob, but not a[download] or URL)
            return navigator.msSaveBlob(
                new Blob([relatorio]),
                "Contracheque.pdf"
            );
        } else {
            const blobURL = window.URL.createObjectURL(new Blob([relatorio]));
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", "Contracheque.pdf");

            if (typeof tempLink.download === "undefined") {
                tempLink.setAttribute("target", "_blank");
            }

            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }
    };

    render() {
        return (
            <Page
                {...this.props}
                ref={this.page}
                titulo={
                    "Demonstrativos de Pagamento - Contracheque " +
                    this.state.dtReferencia
                        .replace(new RegExp("/", "g"), ".")
                        .substring(3)
                }
            >
                {this.page.current && (
                    <div>
                        <Row>
                            <Col tamanho={"lg-6"}>
                                <Box renderRow={false}>
                                    <Row className={"text-center"}>
                                        <Col tamanho={"lg-3"}>
                                            <h5>BRUTO</h5>
                                            <CampoEstatico
                                                valor={
                                                    this.state.contracheque
                                                        .Resumo.Bruto
                                                }
                                                tipo={
                                                    TipoCampoEstatico.dinheiro
                                                }
                                            />
                                        </Col>

                                        <Col tamanho={"lg-3"}>
                                            <h5>DESCONTOS</h5>
                                            <CampoEstatico
                                                valor={
                                                    this.state.contracheque
                                                        .Resumo.Descontos
                                                }
                                                tipo={
                                                    TipoCampoEstatico.dinheiro
                                                }
                                            />
                                        </Col>

                                        <Col tamanho={"lg-3"}>
                                            <h5>LÍQUIDO</h5>
                                            <CampoEstatico
                                                valor={
                                                    this.state.contracheque
                                                        .Resumo.Liquido
                                                }
                                                tipo={
                                                    TipoCampoEstatico.dinheiro
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </Box>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Box renderRow={false}>
                                    <Row>
                                        <Col>
                                            <h2>
                                                <i className="fa fa-plus-circle text-success mr-2"></i>
                                                Rendimentos
                                            </h2>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Descrição</th>
                                                        <th
                                                            style={{
                                                                textAlign:
                                                                    "right",
                                                            }}
                                                        >
                                                            Valor
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.contracheque.Proventos.map(
                                                        (rendimento, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        {
                                                                            rendimento.DS_RUBRICA
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            width: 120,
                                                                            textAlign:
                                                                                "right",
                                                                        }}
                                                                    >
                                                                        <CampoEstatico
                                                                            valor={
                                                                                rendimento.VL_CALCULO
                                                                            }
                                                                            tipo={
                                                                                TipoCampoEstatico.dinheiro
                                                                            }
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        </Col>

                                        <Col>
                                            <h2>
                                                <i className="fa fa-minus-circle text-danger mr-2"></i>
                                                Descontos
                                            </h2>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Descrição</th>
                                                        <th
                                                            style={{
                                                                textAlign:
                                                                    "right",
                                                            }}
                                                        >
                                                            Valor
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.contracheque.Descontos.map(
                                                        (
                                                            desconto: FichaFinancAssistidoEntidade,
                                                            index: any
                                                        ) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        {
                                                                            desconto.DS_RUBRICA
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            width: 120,
                                                                            textAlign:
                                                                                "right",
                                                                        }}
                                                                    >
                                                                        -
                                                                        <CampoEstatico
                                                                            valor={
                                                                                desconto.VL_CALCULO
                                                                            }
                                                                            tipo={
                                                                                TipoCampoEstatico.dinheiro
                                                                            }
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>

                                    <Botao
                                        titulo="Baixar"
                                        tipo={TipoBotao.primary}
                                        tamanho={TamanhoBotao.pequeno}
                                        onClick={this.gerarRelatorio}
                                    />
                                </Box>
                            </Col>
                        </Row>
                    </div>
                )}
            </Page>
        );
    }
}
